import React from 'react';

export const useDownloadFile = () => {
  const [isDownloading, setDownloading] = React.useState(false);
  const download = async (url: string, fileName: string, headers?: any) => {
    try {
      setDownloading(true);
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/octet-stream',
          ...headers
        }
      });
      const blob = await response.blob();
      const urlify = window.URL || window.webkitURL;
      const blobUrl = urlify.createObjectURL(blob);
      const hiddenElement = document.createElement('a');
      hiddenElement.href = blobUrl;
      hiddenElement.target = '_blank';
      hiddenElement.download = fileName;
      hiddenElement.click();
    } catch (error) {
      console.error(error);
    } finally {
      setDownloading(false);
    }
  };

  const downloadWithLink = (fileName, url, openNewTab = true) => {
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', fileName);
    if (openNewTab) {
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener');
    }

    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return {
    download,
    downloadWithLink,
    isDownloading
  };
};
